import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { updateValue } from '../../actions/buy'

export class Buttons extends Component {

  render() {
    return (
      <Button value={this.props.inputValue} onClick={(e) => this.props.updateValue(e.target.value)} >{this.props.inputValue}</Button>
    )
  }
}

const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 0 27vw;
    background-color: #FAFAFA;
    color: #A1A8AE;
    border: none
    font-size: 20px;

    @media (hover: hover) {
      &:hover {
        background-color: #D5DAE1;
      }
    }
`

const mapStateToProps = state => ({
})

const mapDispatchToProps = {
  updateValue
}

export default connect(mapStateToProps, mapDispatchToProps)(Buttons)
